import { Component, EventEmitter, Output, ViewChild } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { ModalDirective } from 'ngx-bootstrap';

import { CBMError } from 'app/models';
import { TaskService } from 'app/services';

@Component({
  selector: 'app-dialog-vild-decode',
  templateUrl: './dialog-vild-decode.component.html'
})
export class DialogVildDecodeComponent {
  @ViewChild('confirmStartVildDecodingDialog') confirmStartVildDecodingDialog: ModalDirective;

  @Output() onConfirm = new EventEmitter<boolean>();

  private readonly modalTimeout = 2000;

  public isDecodingVild = false;
  public isDecodeSuccessfullyStarted = false;
  public decodeVildErrorMessages: CBMError[] = [];

  constructor(private readonly taskService: TaskService, protected translateService: TranslateService) {}

  public show(): void {
    this.confirmStartVildDecodingDialog.show();
  }

  public stopStartVildDecoding(): void {
    this.confirmStartVildDecodingDialog.hide();
  }

  public startVildDecoding(): void {
    this.isDecodingVild = true;
    this.decodeVildErrorMessages = [];

    if (this.isDecodingVild) {
      this.taskService.startDecodeVildTask().subscribe(
        () => {
          this.isDecodeSuccessfullyStarted = true;

          setTimeout(() => {
            this.isDecodingVild = false;
            this.onConfirm.emit(true);
            this.confirmStartVildDecodingDialog.hide();
          }, this.modalTimeout);
        },
        error => {
          this.isDecodingVild = false;

          if (error instanceof CBMError) {
            this.decodeVildErrorMessages.push(error);
          } else if (error instanceof Array) {
            this.decodeVildErrorMessages = error;
          }
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-vild-decode/dialog-vild-decode.component.ts